import React from 'react'

interface MdxErrorBoundaryProps {
  sourcePath?: string
  slug?: string
  children: React.ReactNode
}

interface MdxErrorBoundaryState {
  error: Error | null
  info: React.ErrorInfo | null
}

export class MdxErrorBoundary extends React.Component<
  MdxErrorBoundaryProps,
  MdxErrorBoundaryState
> {
  constructor(props: MdxErrorBoundaryProps) {
    super(props)
    this.state = { error: null, info: null }
  }

  static getDerivedStateFromError(error: Error): MdxErrorBoundaryState {
    return { error, info: null }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    this.setState({ error, info })
    // eslint-disable-next-line no-console
    console.error('[MDX Render Error]', {
      error,
      info,
      slug: this.props.slug,
      sourcePath: this.props.sourcePath,
    })
  }

  render(): React.ReactNode {
    if (this.state.error) {
      return (
        <div className="rounded border border-red-300 bg-red-50 p-4 text-sm text-red-800">
          <div className="font-semibold">MDX render error</div>
          {this.props.slug && (
            <div className="mt-1">
              <span className="font-medium">Slug:</span> {this.props.slug}
            </div>
          )}
          {this.props.sourcePath && (
            <div className="mt-1 break-all">
              <span className="font-medium">Source:</span> {this.props.sourcePath}
            </div>
          )}
          <div className="mt-2 break-all">
            <span className="font-medium">Message:</span>{' '}
            {this.state.error?.message}
          </div>
        </div>
      )
    }
    return this.props.children
  }
}


